// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3PVWe","label":"Completed_label__3O9zz"};